import { AxiosRequestConfig, AxiosResponse } from "axios";
import { CloudGovSurveyClient } from "./survey-api-client";

type ValueOf<T> = T[keyof T];
type HttpMethodLiterals = ValueOf<typeof HttpMethod>;

export const HttpMethod = {
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete",
} as const;

const TypedResources =
  (client: CloudGovSurveyClient, basePath: string) =>
  <T, B>(
    path: string,
    method: HttpMethodLiterals,
    // TODO(adshidtadka): bodyに型引数Bがつけられるようにする
    // https://graffer.atlassian.net/browse/PRODUCTS-8571
    body?: any,
    config?: AxiosRequestConfig,
  ) => {
    switch (method) {
      case "delete":
        return client.http.delete<B, AxiosResponse<T>>(
          `${basePath + path}`,
          body,
        );
      case "get":
        return client.http.get<B, AxiosResponse<T>>(`${basePath + path}`, body);
      case "patch":
        return client.http.patch<B, AxiosResponse<T>>(
          `${basePath + path}`,
          body,
        );
      case "post":
        return client.http.post<B, AxiosResponse<T>>(
          `${basePath + path}`,
          body,
          config,
        );
      case "put":
        return client.http.put<B, AxiosResponse<T>>(`${basePath + path}`, body);
    }
  };

export const TypedCloudGovResource =
  <T, B>(client: CloudGovSurveyClient) =>
  (path: string, method: HttpMethodLiterals, body?: B) =>
    TypedResources(client, `/api/v1`)<T, B>(path, method, body);

export const Resources =
  (client: CloudGovSurveyClient) =>
  (path: string, method: HttpMethodLiterals, body?: any) =>
    TypedResources(client, `/api/v1`)<any, any>(path, method, body);

export const ResourcesV2 =
  (client: CloudGovSurveyClient) =>
  (path: string, method: HttpMethodLiterals, body?: any) =>
    TypedResources(client, `/api/v2`)<any, any>(path, method, body);

export function convert<RawData, T>(factory: (data: RawData) => T) {
  return (resp: AxiosResponse<RawData>): AxiosResponse<T> => {
    return {
      ...resp,
      config: {
        ...resp.config,
        // resp.dataはJSONだが、resp.config.dataはstringのため、factoryにわたすことができない
        data: resp.config.data as any,
      },
      data: factory(resp.data),
    };
  };
}
